<template>
<b-form-group align="left">
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <label>Especialidades: </label>
    <b-form-select  v-model="especialidad"  v-if="!loading" >
        <b-form-select-option v-for="elemento in especialidades" :key="elemento.id" 
        :value="elemento.id">{{ elemento.especialidad }}</b-form-select-option>
    </b-form-select>
    <b-spinner small v-if="loading"></b-spinner>
</b-form-group>
</template>

<script>
export default {
    name: "Especialidades",
    props: { 
    },
    data: () => ({
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
        especialidades: [],
        especialidad: null,
        loading: true,

    }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
    methods: {
        getObtenerEspecialidades() {
            this.$http
                .get(this.$api + "catalogos/obtenerEspecialidades")
                .then((response) => {
                    this.especialidades = response.data.data;
                })
                .catch((error) => {
                    console.error(error);
                }).finally(() =>   
                    this.loading = false
                );
        },
    },
    mounted() {
        this.getObtenerEspecialidades();
    }, 
}
</script>
